"use client"

import Image from 'next/image';
import sanFran from 'app/(unauthenticated)/landing-180/img/san-fran.svg';
import React from 'react';

export const FooterHeart = () => {
  return <div className={'flex flex-col justify-center items-center group'}>
    <div className={'relative'}>
      <Image
        src={sanFran}
        alt='San Francisco'
        width={47}
        height={57}
        className='relative z-10'
      />
      <div
        className='absolute top-[2px] left-1/2 z-0 transition-all duration-500 ease-out opacity-0 group-hover:opacity-100'
        style={{
          transform: 'translate3d(0rem, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
          transformStyle: 'preserve-3d'
        }}
      >
        ❤️
      </div>
    </div>
    <p className='text-gray-400 text-small text-center'>
      Made in San Francisco ❤
    </p>

    <style jsx>{`
      .group:hover > div > div[style*="rotateZ"] {
        transform-origin: center bottom !important;
        transform: translate3d(0rem, 0rem, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(35deg) skew(0deg, 0deg) !important;
      }
    `}</style>
  </div>;
};